// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "user_video_progress".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "user_video_progress" table (1:1 with a DB row, on the wire). */
export const userVideoProgressAtomSchema = z.object({
    id: z.string(),
    userId: z.string(),
    trainingVideoId: z.string(),
    watchedSeconds: z.number(),
    isCompleted: z.boolean(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=userVideoProgress.js.map